import { atom } from "jotai";

export const syncCompletedCountAtom = atom(0);

export const isSyncingAtom = atom(false);
